import { render } from "./IconTeasers.vue?vue&type=template&id=63f63cc8&ts=true"
import script from "./IconTeasers.vue?vue&type=script&lang=ts"
export * from "./IconTeasers.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__